import axios from "axios";

const envOrigin = process.env.REACT_APP_BACKEND_URL;
const pageOrigin = typeof window !== "undefined" ? window.location.origin : envOrigin;
const isLocal = /localhost|127\.0\.0\.1/.test(pageOrigin);
// Custom domain / www variants call the API on the same domain so the browser never blocks it.
export const API_BASE = `${!isLocal && pageOrigin !== envOrigin ? pageOrigin : envOrigin}/api/v1`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
